import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import clsx from "clsx";
import { Grid } from "./Grid";
import { Stack } from "./Stack";
import { SlotsProvider } from "../providers/SlotsProvider";
import { useDefaultProps } from "../providers/utils/defaultProps";
import { mergeSx } from "../system";
import { OverflowingTypography } from "./OverflowingTypography";
export const topAppBarVariants = ["small", "default"];
export const topAppBarClasses = {
    root: "MinervaTopAppBar-root",
    container: "MinervaTopAppBar-container",
    "bottom-container": "MinervaTopAppBar-bottomContainer",
    "title-wrapper": "MinervaTopAppBar-titleWrapper",
    title: "MinervaTopAppBar-title",
    divider: "MinervaTopAppBar-divider",
};
export const topAppBarSlots = {
    title: OverflowingTypography,
};
export const TopAppBar = (props) => {
    const { variant = "default", title, divider, startNode, endNode, subEndNode, slots, slotProps, density = "comfortable", className, sx, ...rest } = useDefaultProps({ component: "TopAppBar", props });
    return (_jsx(SlotsProvider, { baseSlots: topAppBarSlots, slots: slots, children: ({ title: Title }) => (_jsxs(Stack, { className: clsx([topAppBarClasses.root, className]), alignItems: "center", gap: 2, width: "100%", sx: mergeSx({
                borderBottom: divider ? 1 : "none",
                borderColor: (theme) => theme.palette.stroke[100],
                padding: density === "none" ? 0 : 4,
                breakpoints: {
                    md: {
                        padding: density === "comfortable" ? 8 : density === "dense" ? 4 : 0,
                    },
                },
            }, sx), ...rest, children: [(title || startNode || endNode) && (_jsxs(Grid, { container: true, gap: 2, alignItems: "center", className: clsx([topAppBarClasses.container, className]), children: [startNode, _jsx(Grid, { item: true, xs: true, minWidth: "25%", className: clsx([topAppBarClasses["title-wrapper"], className]), children: variant === "small" ? (typeof title === "string" ? (_jsx(Title, { variant: "h6", fontWeight: "bold", ...slotProps?.title, className: clsx([
                                    topAppBarClasses.title,
                                    slotProps?.title?.className,
                                ]), children: title })) : (title)) : null }), endNode] })), variant === "default" && (title || subEndNode) && (_jsxs(Grid, { container: true, className: clsx([topAppBarClasses["bottom-container"], className]), gap: 2, alignItems: "center", children: [_jsx(Grid, { item: true, xs: true, minWidth: "25%", className: clsx([topAppBarClasses["title-wrapper"], className]), children: typeof title === "string" ? (_jsx(Title, { variant: "h6", fontWeight: "bold", ...slotProps?.title, className: clsx([
                                    topAppBarClasses.title,
                                    slotProps?.title?.className,
                                ]), children: title })) : (title) }), subEndNode] }))] })) }));
};
export default TopAppBar;
//# sourceMappingURL=TopAppBar.js.map